module.exports = __webpack_public_path__ + "static/media/centro_platea_2.db050b20.mp4";